/* ====================================================================
   FYP CART — quantity steppers (10 Jul 2026)
   Progressive enhancement only. Wraps Impact's existing
   input[is="quantity-input"] with − / + buttons that set the value and
   dispatch the same 'change' event a keyboard edit produces, so
   Impact's line-item-quantity AJAX flow is reused untouched.
   No cart logic is duplicated. Revert: delete this file + the script
   line in layout/theme.liquid.
   ==================================================================== */
(function () {
  'use strict';

  var SCOPES = '#cart-drawer, .shopify-section--main-cart';

  function makeButton(dir, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fyp-qty__btn';
    b.setAttribute('aria-label', label);
    b.textContent = dir < 0 ? '−' : '+';
    return b;
  }

  function enhance(liq) {
    if (liq.dataset.fypStepper) return;
    var input = liq.querySelector('input.quantity-input');
    if (!input) return;
    liq.dataset.fypStepper = '1';

    var wrap = document.createElement('div');
    wrap.className = 'fyp-qty';
    input.parentNode.insertBefore(wrap, input);

    var minus = makeButton(-1, 'Decrease quantity');
    var plus = makeButton(1, 'Increase quantity');
    wrap.appendChild(minus);
    wrap.appendChild(input);
    wrap.appendChild(plus);

    function bounds() {
      return {
        min: parseFloat(input.min) || 1,
        max: input.max !== '' && input.max !== null && input.max !== undefined && input.max !== 'null' && input.max ? parseFloat(input.max) : Infinity,
        step: parseFloat(input.step) || 1
      };
    }

    function sync() {
      var b = bounds();
      var v = parseFloat(input.value) || b.min;
      minus.disabled = input.disabled || v <= b.min;
      plus.disabled = input.disabled || v >= b.max;
    }

    function nudge(dir) {
      if (input.disabled) return;
      var b = bounds();
      var v = (parseFloat(input.value) || b.min) + dir * b.step;
      v = Math.min(b.max, Math.max(b.min, v));
      if (String(v) !== input.value) {
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
    }

    minus.addEventListener('click', function () { nudge(-1); });
    plus.addEventListener('click', function () { nudge(1); });
    input.addEventListener('change', sync);
    input.addEventListener('input', sync);
    sync();
  }

  function scan() {
    document.querySelectorAll(SCOPES).forEach(function (scope) {
      scope.querySelectorAll('line-item-quantity').forEach(enhance);
    });
  }

  /* 16 Oct 2026 (NEW-03): when the drawer re-renders (e.g. the last line is removed and the
     empty state replaces the list), focus fell to <body>. If the drawer is open and focus has
     been lost, put it on the empty-state button, else the first focusable control. Never steals
     focus while the drawer is closed or while something inside it already has focus. */
  var focusPending = false;
  function recoverFocus() {
    if (focusPending) return;
    focusPending = true;
    requestAnimationFrame(function () {
      focusPending = false;
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      var isOpen = drawer.open === true || drawer.hasAttribute('open');
      if (!isOpen) return;
      var ae = document.activeElement;
      if (ae && ae !== document.body && drawer.contains(ae)) return;
      var target = drawer.querySelector('.empty-state a, .empty-state button, .empty-state .button') ||
                   drawer.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
    });
  }

  function start() {
    scan();
    /* Impact re-renders cart regions after AJAX updates — re-enhance. */
    new MutationObserver(function () { scan(); recoverFocus(); })
      .observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:change', function () { scan(); recoverFocus(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
